/**
 * O menu lateral da camada PLATAFORMA (Painel do Operador, só o dono).
 *
 * Saiu de `Layout.tsx` em 24/09/2026 quando o item "Pareceres" entrou: o Layout está na dívida do
 * portão de tamanho e só pode encolher. Capacidade nova entra por EXTRAÇÃO — a lista é só dado.
 * No Operador o menu é o da PLATAFORMA, não o menu operacional do cliente: só itens de operar a plataforma.
 */
import {
  LayoutDashboard,
  Building2,
  Activity,
  FileText,
  Smartphone,
  Scale,
  ScanLine,
  ClipboardCheck,
  ShieldCheck,
  Bell,
  Settings,
} from "lucide-react";
import { ROTA_USUARIOS_PLATAFORMA } from "../lib/operador";

export type ItemMenuOperador = { to: string; label: string; icon: typeof LayoutDashboard; exact?: boolean };

export const MENU_DO_OPERADOR: ItemMenuOperador[] = [
  { to: "/operador", label: "Painel", icon: LayoutDashboard, exact: true },
  { to: "/operador/clientes", label: "Clientes", icon: Building2 },
  { to: "/operador/telemetria", label: "Telemetria", icon: Activity },
  // 👑 24/09: item PRÓPRIO (mock aprovado) — cada parecer da IA, custo e régua. Só leitura.
  { to: "/operador/pareceres", label: "Pareceres", icon: FileText },
  { to: "/operador/canais", label: "Canais de Acesso", icon: Smartphone },
  { to: "/operador/base-comparativa", label: "Base Comparativa", icon: Scale },
  { to: "/operador/conferencia-folha", label: "Conferência de folha", icon: ScanLine },
  { to: "/operador/auditorias", label: "Auditorias", icon: ClipboardCheck },
  { to: "/operador/seguranca", label: "Segurança", icon: ShieldCheck },
  // Push da PLATAFORMA (👑 18/09) — mesma tela, rota da camada; o dono soma os eventos soOperador.
  { to: "/operador/notificacoes", label: "Notificações", icon: Bell },
  // Usuários DA PLATAFORMA — rota própria (era /usuarios, a mesma da empresa,
  // e o dono dentro do Átomo caía aqui). Ver src/client/lib/operador.ts.
  { to: ROTA_USUARIOS_PLATAFORMA, label: "Usuários", icon: Settings },
];
